module.exports = __webpack_public_path__ + "img/category-new-released-hover.6a6c2a2f.png";